import { Dispatch } from 'redux';
import HIDEvent from '../../HID/_events/HIDEvent';
import { OnZoom } from '../../Document/_actions/DocumentActions';

const HIDEvents = [
	/*
		HIDEvent('left', (e:KeyboardEvent, dispatch: Dispatch) => dispatch(StageActions.OnPan(10, 0)), 'keydown', true),
		HIDEvent('right', (e:KeyboardEvent, dispatch: Dispatch) => dispatch(StageActions.OnPan(-10, 0)), 'keydown', true),
		HIDEvent('up', (e:KeyboardEvent, dispatch: Dispatch) => dispatch(StageActions.OnPan(0, 10)), 'keydown', true),
		HIDEvent('down', (e:KeyboardEvent, dispatch: Dispatch) => dispatch(StageActions.OnPan(0, -10)), 'keydown', true),
		HIDEvent('shift+left', (e:KeyboardEvent, dispatch: Dispatch) => dispatch(StageActions.OnPan(100, 0)), 'keydown', true),
		HIDEvent('shift+right', (e:KeyboardEvent, dispatch: Dispatch) => dispatch(StageActions.OnPan(-100, 0)), 'keydown', true),
		HIDEvent('shift+up', (e:KeyboardEvent, dispatch: Dispatch) => dispatch(StageActions.OnPan(0, 100)), 'keydown', true),
		HIDEvent('shift+down', (e:KeyboardEvent, dispatch: Dispatch) => dispatch(StageActions.OnPan(0, -100)), 'keydown', true),
	*/

	HIDEvent('ctrl+plus', (e: KeyboardEvent, dispatch: Dispatch) => {
		e.preventDefault();
		return dispatch(OnZoom(10))
	}, 'keypress', true),

	HIDEvent('ctrl+-', (e: KeyboardEvent, dispatch: Dispatch) => {
		e.preventDefault();
		return dispatch(OnZoom(-10))
	}, 'keypress', true),

	HIDEvent('wheel', (e: WheelEvent, dispatch: Dispatch) => {
		if(e.deltaY == 0) return;
		const zoomAmount = e.deltaY < 1 ? 10 : -10;
		return dispatch(OnZoom(
			zoomAmount,
			e.clientX,
			e.clientY,
		))
	})
]

export default HIDEvents